import { auth } from "@Firebase/firebase";
import { DealerDashboardData } from "@Hooks/useDealersDashboard";
import { DealerDashboardFilters } from "@Pages/DealersDashboard/DealersDashboard";
import axios from "axios";

export const getDealersDashboardData = (
  query?: DealerDashboardFilters
): (() => Promise<DealerDashboardData>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/dealers_dashboard/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return response.data;
  };
};

export const getDealerFinanceData = (
  id: string,
  query?: DealerDashboardFilters
): (() => Promise<DealerDashboardData>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/dealer_finance/${id}/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return response.data;
  };
};
